import type { CatalogPage, CatalogQuery } from '@pipi/shared';
import { useEffect, useMemo, useState } from 'react';
import { api } from '../lib/api';

export function useCatalog(query: CatalogQuery, delay = 0) {
  const key = useMemo(() => JSON.stringify(query), [query]);
  const [page, setPage] = useState<CatalogPage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const timer = window.setTimeout(() => {
      setLoading(true);
      void api.catalog(JSON.parse(key) as CatalogQuery)
        .then((next) => {
          if (cancelled) return;
          setPage(next);
          setError(null);
        })
        .catch((requestError) => {
          if (!cancelled) setError(requestError instanceof Error ? requestError.message : '曲库加载失败');
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
    }, delay);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [key, delay]);

  return { page, loading, error, reload: () => api.catalog(query).then(setPage) };
}
